import { render, staticRenderFns } from "./carinfo.vue?vue&type=template&id=0d20694c&scoped=true&"
import script from "./carinfo.vue?vue&type=script&lang=js&"
export * from "./carinfo.vue?vue&type=script&lang=js&"
import style0 from "./carinfo.vue?vue&type=style&index=0&id=0d20694c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20694c",
  null
  
)

export default component.exports